import React, { useState } from "react"
import Link from "next/link"
import Cookies from "js-cookie"

export default function AcceptCookies(props) {

  const cookies_accept = Cookies.get("cookies_accept") ? true : false;
  const [close, setClose] = useState(false)
  const Accept = () => {
    Cookies.set("cookies_accept", true, { expires: 3650, secure: true, sameSite: 'strict' })
    setClose(true)
  }

  return (
    <>
      {cookies_accept === false && close === false && (
        <div className="fixed bottom-0 left-0 right-0 z-[9999999999999999999999999] bg-black shadow-lg">
          <div className="max-w-7xl mx-auto px-4 py-5 sm:px-6">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex-1 text-center sm:text-left">
                <p className="text-sm text-white">
                  We uses cookies for the functioning of the website. To learn more about how we use cookies please read our
                  <Link
                    href="/terms-of-use"
                    rel="noopener noreferrer"
                    target="_blank"
                    className="text-white hover:text-gray-300 underline mx-1"
                  >
                    Terms of Service
                  </Link>
                  and
                  <Link
                    href="/privacy-policy"
                    rel="noopener noreferrer"
                    target="_blank"
                    className="text-white hover:text-gray-300 underline mx-1"
                  >
                    Privacy Policy
                  </Link>
                  .
                </p>
              </div>
              <div className="flex-shrink-0">
                <button
                  type="button"
                  onClick={Accept}
                  style={{ backgroundColor: '#fbb040' }}
                  className="w-full sm:w-auto px-6 py-2 
                  border-none
                  hover:opacity-90 text-white font-medium rounded-lg transition-colors duration-200"
                >
                  Got it
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}